<template>
    <v-progress-linear v-if="loading"
                       :indeterminate="true"
                       color="primary"/>
    <div class="ma-6 mb-6 text-h5 kpmgPrimary-900">{{ title }}</div>
    <template v-if="!loading">
        <slot name="content"></slot>
    </template>
</template>

<script lang="ts">
import {computed, defineComponent, type PropType} from "vue"
import type {TBaseStore} from "@/stores/BaseStore/types/TBaseStore";


export default defineComponent({
    components: {
    },
    props: {
        baseStore: {
            type: Object as PropType<TBaseStore<string>>,
            required: true
        },
        title: {
            type: String,
            default: ""
        },
    },
    setup(props) {
        const loading = computed((): boolean => {
            return !props.baseStore.initialized;
        })
        return {

            //computed
            loading,
        }
    }
})
</script>